import { DataBox, createDataBox, createDataBoxDefault } from 'app/common/data-box-store'
import {
  GET_KLASSES_CHAINS,
  convertParams,
  convertResult,
} from 'app/common/api/requests/reports/klasses_chains/get'
import { ItemType } from 'app/common/ui-next/plain-selector'
import { api } from 'app/api'

type EducationLevelItem = ItemType & { parallels?: string[] }
type EducationLevels = Array<EducationLevelItem>

class EducationLevelsFilterDataBox extends DataBox<EducationLevels> {}

export const defaultEducationLevels: EducationLevels = []
export const educationLevelsFilter = createDataBox(
  'educationLevelsFilter',
  defaultEducationLevels,
  EducationLevelsFilterDataBox,
)

export const defaultEducationLevelsDataReceiver = async (
  schoolId: string,
  schoolYearId: string,
  parallels: string[],
) => {
  if (!schoolId || !schoolYearId) return []

  const chains = await api.request(GET_KLASSES_CHAINS, {
    error: 'Не удалось получить уровни образования',
    params: { schoolId, schoolYearId },
    convertions: {
      convertParams,
      convertResult,
    },
  })
  if (!chains) return []

  return Object.keys(chains)
    .filter(
      (title) => !parallels.length || chains[title].some((value) => parallels.includes(value)),
    )
    .map((title) => ({ id: title, title, parallels: chains[title] }))
}

export const defaultEducationLevelsSelection: Array<string> = []
export const educationLevelsFilterSelection = createDataBoxDefault<Array<string>>(
  'educationLevelsFilterSelection',
  defaultEducationLevelsSelection,
)
